import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";

const AddressComponent = () => {
  const { workerUser } = useOutletContext();
  const [residentialStreetAddress, setResidentialStreetAddress] = useState(
    workerUser.residentialStreetAddress || ""
  );
  const [residentialSuburbStatePostcode, setResidentialSuburbStatePostcode] =
    useState(workerUser.primaryLocation || "");
  const [postalStreetAddress, setPostalStreetAddress] = useState(
    workerUser.postalStreetAddress || ""
  );
  const [postalSuburbStatePostcode, setPostalSuburbStatePostcode] = useState(
    workerUser.primaryLocation || ""
  );
  const [isSameAsResidential, setIsSameAsResidential] = useState(false);

  const handleCheckboxChange = () => {
    setIsSameAsResidential((prevState) => !prevState);

    if (!isSameAsResidential) {
      setPostalStreetAddress(residentialStreetAddress);
      setPostalSuburbStatePostcode(residentialSuburbStatePostcode);
    } else {
      setPostalStreetAddress("");
      setPostalSuburbStatePostcode("");
    }
  };

  return (
    <div className="address-account-settings">
      <h3>Residential Address</h3>

      <div className="usrnmepsswrd-password-section">
        <label htmlFor="residentialStreetAddress">Street Address</label>
        <input
          type="text"
          id="residentialStreetAddress"
          value={residentialStreetAddress}
          onChange={(e) => setResidentialStreetAddress(e.target.value)}
        />
      </div>

      <div className="usrnmepsswrd-password-section">
        <label htmlFor="residentialSuburbStatePostcode">
          Suburb/state/postcode
        </label>
        <input
          type="text"
          id="residentialSuburbStatePostcode"
          value={residentialSuburbStatePostcode}
          onChange={(e) => setResidentialSuburbStatePostcode(e.target.value)}
        />
      </div>

      <h3>Postal Address</h3>
      <div className="postal-address-container">
        <label>
          <input
            type="checkbox"
            checked={isSameAsResidential}
            onChange={handleCheckboxChange}
          />
          Same as residential address
        </label>
      </div>

      <label htmlFor="postalStreetAddress">Street Address</label>
      <input
        type="text"
        id="postalStreetAddress"
        value={postalStreetAddress}
        onChange={(e) => setPostalStreetAddress(e.target.value)}
        disabled={isSameAsResidential}
      />

      <label htmlFor="postalSuburbStatePostcode">Suburb/state/postcode</label>
      <input
        type="text"
        id="postalSuburbStatePostcode"
        value={postalSuburbStatePostcode}
        onChange={(e) => setPostalSuburbStatePostcode(e.target.value)}
        disabled={isSameAsResidential}
      />

      <button className="address-save-button">Save Changes</button>
    </div>
  );
};

export default AddressComponent;
